import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateSupplierSchema } from "@/v2/schema/supplier";
import { Supplier } from "@/v2/types";

export default async function UpdateSupplier({
    id,
    data,
}: {
    id: string;
    data: CreateSupplierSchema;
}): Promise<Supplier> {
    const res = await apiClientWithRefreshToken({
        url: `/suppliers/${id}`,
        method: "PUT",
        data: data,
    });

    return res.data;
}
